import {
  fetchMultipleProducts,
  fetchProduct,
  fetchProductActionLogs,
  fetchProducts,
  fetchProductsXlsx,
  importProductsXlsx,
} from '../queries/products.queries'

import { skipToken, useMutation, useQuery } from '@tanstack/react-query'

export const useProducts = () =>
  useQuery({
    queryKey: ['products'],
    queryFn: fetchProducts,
    staleTime: 60_000,
  })

export const useProduct = (id: number) =>
  useQuery({
    queryKey: ['product', id],
    queryFn: Number.isNaN(id) || id === 0 ? skipToken : () => fetchProduct(id),
  })

export const useMultipleProducts = (ids: number[]) =>
  useQuery({
    queryKey: ['multipleProducts', ids],
    queryFn: () => {
      if (ids.length === 0) {
        return []
      }
      return fetchMultipleProducts(ids)
    },
  })

export const useExportProductsXlsx = () =>
  useMutation({
    mutationFn: fetchProductsXlsx,
  })

export const useImportProductsXlsx = () =>
  useMutation({
    mutationFn: importProductsXlsx,
  })

export const useProductActionLogs = (productId?: number) =>
  useQuery({
    queryKey: ['product-action-logs', productId],
    queryFn: productId ? () => fetchProductActionLogs(productId) : skipToken,
  })
